export enum CDHAppEnvironment {
  DEV = 'dev',
  ACC = 'acc',
  PRD = 'prd',
}
